// Headers
if (document.getElementById("progress-bar")) {
  const header = document.querySelector(".header");
  const headerHeight = header.offsetHeight;

  const processScroll = () => {
    const docElem = document.documentElement;
    const docBody = document.body;
    const scrollTop = docElem.scrollTop || docBody.scrollTop;
    const scrollBottom =
      (docElem.scrollHeight || docBody.scrollHeight) - window.innerHeight;
    const scrollPercent = (scrollTop / scrollBottom) * 100 + "%";

    // Set the CSS variables with the correct units
    document
      .getElementById("progress-bar")
      .style.setProperty("--scrollHeaderHeight", `${headerHeight - 7}px`);
    document
      .getElementById("progress-bar")
      .style.setProperty("--scrollAmount", scrollPercent);
  };

  document.addEventListener("scroll", processScroll);
}
